import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'group',
    `
		width: 45%;

		@media (max-width: 720px) {
			width: 100%;

			&:first-of-type {
				margin-bottom: 15px;
			}
		}
	`
  ],
  [
    'label',
	theme => `
		:lang(ar) {
			transform: scaleX(-1);
			direction: rtl;
		}
		padding: 5px 8px;
		font-size: 14px;
		line-height: 1.5;
		background-color: ${theme.survey.color.light};
		color: ${theme.survey.color.default};
		border-radius: 4px;
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
		box-sizing: border-box;
	`
  ],
  [
    'content',
    theme => `
		border: 1px solid ${theme.survey.color.light};
		border-radius: 4px;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		min-height: 132px;
		max-height: 235px;
		overflow-y: auto;
		box-sizing: border-box;
	`
  ]
]);
